import { createPostEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PostSendPasswordResetLinkRequest = {
	userId: number;
	shardName?: string;
};

export const postSendPasswordResetLink = createPostEndpoint<PostSendPasswordResetLinkRequest, void>(
	(request) => `/api/v3/core/users/${request?.userId}/links/password-reset/send`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
